export interface Lacado {
  id: number
  slug: string
  nombre: string
  imagen: string
  categoria: string
}

export const lacados: Lacado[] = [
  { id: 1,  slug: 'blanco',        nombre: 'L-01 / BLANCO',        imagen: '/images/lacados/blanco.png',        categoria: 'mate' },
  { id: 2,  slug: 'negro',         nombre: 'L-02 / NEGRO',         imagen: '/images/lacados/negro.png',         categoria: 'mate' },
  { id: 3,  slug: 'hueso',         nombre: 'L-03 / HUESO',         imagen: '/images/lacados/hueso.png',         categoria: 'mate' },
  { id: 4,  slug: 'gris',          nombre: 'L-04 / GRIS',          imagen: '/images/lacados/gris.png',          categoria: 'mate' },
  { id: 5,  slug: 'gris_rosado',   nombre: 'L-05 / GRIS ROSADO',   imagen: '/images/lacados/gris_rosado.png',   categoria: 'mate' },
  { id: 6,  slug: 'tulipan',       nombre: 'L-06 / TULIPAN',       imagen: '/images/lacados/tulipan.png',       categoria: 'mate' },
  { id: 7,  slug: 'perla',         nombre: 'L-07 / PERLA',         imagen: '/images/lacados/perla.png',         categoria: 'mate' },
  { id: 8,  slug: 'gris_perla',    nombre: 'L-08 / GRIS PERLA',    imagen: '/images/lacados/gris_perla.png',    categoria: 'mate' },
  { id: 9,  slug: 'chocolate',     nombre: 'L-09 / CHOCOLATE',     imagen: '/images/lacados/chocolate.webp',    categoria: 'mate' },
  { id: 10, slug: 'antracita',     nombre: 'L10 / ANTRACITA',      imagen: '/images/lacados/antracita.png',     categoria: 'mate' },
  { id: 11, slug: 'beige_verdoso', nombre: 'L11 / BEIGE VERDOSO',  imagen: '/images/lacados/beige_verdoso.png', categoria: 'mate' },
  { id: 12, slug: 'denim',         nombre: 'L12 / DENIM',          imagen: '/images/lacados/denim.png',         categoria: 'mate' },
  { id: 13, slug: 'lino',          nombre: 'L-13 / LINO',          imagen: '/images/lacados/lino.png',          categoria: 'mate' },
  { id: 14, slug: 'matcha',        nombre: 'L-14 / MATCHA',        imagen: '/images/lacados/matcha.png',        categoria: 'mate' },
  { id: 15, slug: 'nacar',         nombre: 'L-15 / NACAR',         imagen: '/images/lacados/nacar.png',         categoria: 'mate' },
]
